import name from './name'

const selectSliceData = state => state[name]

const selectUserAuthenticated = state => selectSliceData(state).userAuthenticated

export {
  selectUserAuthenticated
}
